import { VenueUpdateNotificationInput } from '../../graphql/API';
import { venueUpdateNotifications } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueUpdateNotificationsApi = async (
  input: VenueUpdateNotificationInput,
): Promise<string> => {
  const result = await executeGql<string>(venueUpdateNotifications, { input });
  return processGqlResult<string>('venueUpdateNotifications', result);
};
